import { render } from "./Requisite.vue?vue&type=template&id=33ae562c&scoped=true"
import script from "./Requisite.vue?vue&type=script&lang=js"
export * from "./Requisite.vue?vue&type=script&lang=js"

import "./Requisite.vue?vue&type=style&index=0&id=33ae562c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ae562c"]])

export default __exports__